<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard</router-link>
      <span class="text-white"> <i class="fa fa-ellipsis-v px-2"></i>Employee
      </span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <card header-classes="bg-transparent">
        <modal :show.sync="modals.newStaffModal" modal-classes="modal-dialog-centered modal-lg">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body">
              <PageSpinner :onloader="onloader" />
              <div class="row">
                <div class="col">
                  <img v-if="ImgPathval" :src="ImgPathval" class="img-fluid" />
                  <img v-else src="/img/brand/empty.png" class="img-fluid" />
                </div>
                <div class="col">
                  <ImageUploader @emitOutImgPathval="updatePassportVal" />
                </div>
              </div>
              <div class="row">


                <div class="col-md-4">
                  <div class="form-group">
                    <label>Surname</label>
                    <input v-model="LastNameval" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>First Name</label>
                    <input v-model="FirstNameval" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Other Name</label>
                    <input v-model="MiddleNameval" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Email Address</label>
                    <input type="email" v-model="EmailAddressval" class="form-control" required />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Phone No.</label>
                    <input type="tel" v-model="PhoneNoval" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Sex</label>
                    <select v-model="SexIdval" class="form-control">
                      <option value="0"></option>
                      <option value="10">Male</option>
                      <option value="11">Female</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Marital Status</label>
                    <select v-model="MaritalStatusIdval" class="form-control">
                      <option value="0"></option>
                      <option value="12">Married</option>
                      <option value="13">Single</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>User Status</label>
                    <select v-model="UserStatusIdval" class="form-control">
                      <option value="0"></option>
                      <option v-for="item in UserStatusItem" :key="item.userStatusId" v-bind:value="item.userStatusId">
                        {{ item.userStatusName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Password</label>
                    <input v-model="UserPasswordval" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template slot="footer">
            <base-button type="default" @click="modals.newStaffModal = false">Cancel
            </base-button>
            <button class="btn btn-default" @click.prevent="submitdata()">
              Submit
            </button>
          </template>
        </modal>

        <div>
          <div class="justify-content-end form-inline">
            <button type="button" @click.prevent="OpenNewStaff" class="btn btn-default">
              <i class="fa fa-plus"></i>Add New
            </button>
            <base-input class="input-group-alternative" placeholder="Search here..." addon-left-icon="fa fa-search"
              v-model="searchval">
            </base-input>
          </div>
          <div>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a href="#" class="nav-link" :class="{active: activeTab==='active'}" @click.prevent="activeTab='active'">Active <span class="badge badge-light ml-2">{{ activeUsers.length || 0 }}</span></a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" :class="{active: activeTab==='deleted'}" @click.prevent="activeTab='deleted'">Deleted <span class="badge badge-light ml-2">{{ deletedUsers.length || 0 }}</span></a>
              </li>
            </ul>

            <div class="tab-content mt-3">
              <div class="tab-pane" :class="activeTab==='active' ? 'active show' : ''" v-if="activeTab==='active'">
                <div class="mt-2 row">
                  <div class="col-md-3" v-for="item in activeUsers" :key="item.id || item.Id">
                    <div class="card text-center m-2 animate__animated animate__backInUp">
                      <div class="card bg-success shrink my-3">
                        <div class="card-body text-center">
                          <img v-if="item.passport || item.Passport" :src="item.passport || item.Passport" class="rounded" alt="" height="50" />
                          <img v-else src="/img/brand/loguser.png" class="rounded" alt="" height="50" />
                          <h5 class="text-white">{{ item.fullName || item.FullName }}</h5>
                          <h6 class="text-white">{{ item.userStatusName || item.UserStatusName }}</h6>
                          <h6 class="text-white"><small>{{ item.emailAddress || item.EmailAddress }} || {{ item.phoneNo || item.PhoneNo }}</small> </h6>
                          <div class="text-center">
                            <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item)">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button class="btn btn-danger btn-sm my-2" v-on:click="DeleteUndeleteUser(item.id || item.Id)">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane" :class="activeTab==='deleted' ? 'active show' : ''" v-if="activeTab==='deleted'">
                <div class="mt-2 row">
                  <div class="col-md-3" v-for="item in deletedUsers" :key="item.id || item.Id">
                    <div class="card text-center m-2 animate__animated animate__backInUp">
                      <div class="card bg-info shrink my-3">
                        <div class="card-body text-center">
                          <img v-if="item.passport || item.Passport" :src="item.passport || item.Passport" class="rounded" alt="" height="50" />
                          <img v-else src="/img/brand/loguser.png" class="rounded" alt="" height="50" />
                          <h5 class="text-white">{{ item.fullName || item.FullName }}</h5>
                          <h6 class="text-white">{{ item.userStatusName || item.UserStatusName }}</h6>
                          <h6 class="text-white"><small>{{ item.emailAddress || item.EmailAddress }} || {{ item.phoneNo || item.PhoneNo }}</small> </h6>
                          <div class="text-center">
                            <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item)">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button class="btn btn-default btn-sm" v-on:click="DeleteUndeleteUser(item.id || item.Id)">
                              <i class="fa fa-trash-restore"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-center my-3" v-if="loading">
                <div class="ellipsis">
                  <span></span><span></span><span></span>
                </div>
              </div>
              <div class="text-center my-2" v-else-if="!hasMore">
                <small class="text-muted">No more records</small>
              </div>
              <div ref="infiniteSentinel" style="height:1px"></div>
            </div>
          </div>

        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageSpinner from "@/components/PageSpinner"
import Alert from "@/mixins/Alert.mixins"
import ImageUploader from "@/components/ImageUploader"
export default {
  name: "AdminUser",
  mixins: [Alert],
  components: {
    PageSpinner,
    ImageUploader
  },
  data() {
    return {
      accessDetails: null,
      IdVal: 1,
      ImgPathval: "",
      ContactIdval: 1,
      FirstNameval: "",
      MiddleNameval: "",
      LastNameval: "",
      PhoneNoval: "",
      EmailAddressval: "",
      UserPasswordval: "",
      SexIdval: 0,
      UserStatusIdval: 0,
      MaritalStatusIdval: 0,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 0,
      totalRecords: 0,
      nextPage: null,
      previousPage: null,
      loading: false,
      hasMore: true,
      activeTab: 'active',
      AdminUserItem: null,
      UserStatusItem: null,
      searchval: "",
      isModified: false,
      openform: false,
      inputdisable: false,
      onloader: "none",
      modals: {
        newStaffModal: false
      },
    };
  },
  computed: {
    ...mapState({
      stateitems: (state) => state.addressinfo.stateitems,
      userStatusitems: (state) => state.usersdata.userStatus,
    }),
    searchedResultQuery() {
      if (!this.AdminUserItem) return [];

      if (this.searchval) {
        return this.AdminUserItem.filter((item) => {
          return this.searchval
            .toLowerCase()
            .split(" ")
            .every(
              (v) =>
                ((item.fullName || item.FullName || "").toString().toLowerCase().includes(v)) ||
                ((item.emailAddress || item.EmailAddress || "").toString().toLowerCase().includes(v)) ||
                ((item.phoneNo || item.PhoneNo || "").toString().toLowerCase().includes(v)) ||
                ((item.userStatusName || item.UserStatusName || "").toString().toLowerCase().includes(v))
            );
        });
      } else {
        return this.AdminUserItem || [];
      }
    },
    activeUsers() {
      const list = this.searchedResultQuery || [];
      return list.filter((i) => {
        const deleted = (i && (i.isDeleted || i.IsDeleted || i.isdeleted || i.Isdeleted)) || false;
        return !deleted;
      });
    },
    deletedUsers() {
      const list = this.searchedResultQuery || [];
      return list.filter((i) => {
        return (i && (i.isDeleted || i.IsDeleted || i.isdeleted || i.Isdeleted)) || false;
      });
    },
  },
  methods: {
    OpenNewStaff() {
      this.ImgPathval = "";
      this.FirstNameval = "";
      this.EmailAddressval = "";
      this.PhoneNoval = "";
      this.MiddleNameval = "";
      this.LastNameval = "";
      this.SexIdval = 0;
      this.UserPasswordval = "";
      this.MaritalStatusIdval = 0;
      this.UserStatusIdval = 0
      this.openform = true;
      this.isModified = false;
      this.modals.newStaffModal = true;
    },
    ResetInput() {
      this.ImgPathval = "";
      this.FirstNameval = "";
      this.EmailAddressval = "";
      this.PhoneNoval = "";
      this.MiddleNameval = "";
      this.LastNameval = "";
      this.SexIdval = 0;
      this.UserPasswordval = "";
      this.MaritalStatusIdval = 0;
      this.UserStatusIdval = 0
      this.openform = true;
      this.isModified = false;
    },
    // alias for other code that calls lowercase resetInput
    resetInput() {
      this.ResetInput();
    },
    updatePassportVal(data) {
      this.ImgPathval = data;
    },
    edititem(item) {
      this.IdVal = item.id || item.Id;
      const passport = item.passport || item.Passport || item.PassportPath || null;
      if (passport != null) {
        this.uploadedimage = passport;
      }
      this.ImgPathval = passport;
      this.FirstNameval = item.firstName || item.FirstName || '';
      this.MiddleNameval = item.middleName || item.MiddleName || '';
      this.LastNameval = item.lastName || item.LastName || '';
      this.EmailAddressval = item.emailAddress || item.EmailAddress || '';
      this.PhoneNoval = item.phoneNo || item.PhoneNo || '';
      this.SexIdval = item.sexId || item.SexId || 0;
      this.UserStatusIdval = item.userStatusId || item.userStatusId || 0;
      this.MaritalStatusIdval = item.maritalStatusId || item.MaritalStatusId || 0;     
      this.isModified = true;
      this.modals.newStaffModal = true;
    },
    DeleteUndeleteUser(Id) {
      this.onloader = "flex";

      let userData = { userId: Id }
      this.$store
        .dispatch("User/DeleteUndeleteUser", userData)
        .then((resp) => {
          if (resp.responseCode == '00') {
            this.GetEmployeeAll()
            this.ResetInput();
            this.ShowAlertSuccess('Proccessed Successfully', '');
          } else {
            this.ShowAlertError(resp.responseMessage, '');
          }
          this.onloader = "none";

        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    submitdata() {
      // Fluent validation before submitting
      const validation = this.validateSubmitData();
      if (!validation.valid) {
        // Show aggregated validation messages
        this.ShowAlertWarning('Validation error', validation.message);
        return;
      }
      let UserId = this.IdVal;
      let Passport = this.ImgPathval;
      let FirstName = this.FirstNameval;
      let MiddleName = this.MiddleNameval;
      let LastName = this.LastNameval;
      let EmailAddress = this.EmailAddressval;
      let MaritalStatusId = this.MaritalStatusIdval;
      let PhoneNumber = this.PhoneNoval;
      let SexId = this.SexIdval;
      let userStatusId = this.UserStatusIdval
      let userPassword = this.UserPasswordval

      this.onloader = "flex";

      let userdata = {};
      this.onloader = "flex";
      let operationVal = "";
      if (this.isModified == false) {
        operationVal = "Employee/CreateEmployee";
        userdata = {
          Passport,
          MaritalStatusId,
          FirstName,
          MiddleName,
          LastName,
          EmailAddress,
          PhoneNumber,
          SexId,
          userStatusId,
          userPassword
        }
      } else {
        operationVal = "Employee/UpdateEmployee";
        userdata = {
          UserId,
          Passport,
          MaritalStatusId,
          FirstName,
          MiddleName,
          LastName,
          EmailAddress,
          PhoneNumber,
          SexId,
          userStatusId,
          userPassword
        }
      }
      this.$store
        .dispatch(operationVal, userdata)
        .then((resp) => {

          if (resp.responseCode == '00') {
            this.GetEmployeeAll();
            this.resetInput();
            this.modals.classNoteModal = false;
            this.ShowAlertSuccess('Submitted successfully', '');
          } else {
            this.ShowAlertError(resp.responseMessage, '');
          }
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },

    validateSubmitData() {
      const errors = [];
      const trim = (v) => (v || '').toString().trim();
      const email = trim(this.EmailAddressval);
      const first = trim(this.FirstNameval);
      const last = trim(this.LastNameval);
      const phone = trim(this.PhoneNoval);

      if (!first) errors.push('First name is required.');
      if (!last) errors.push('Surname is required.');

      if (!email) {
        errors.push('Email address is required.');
      } else {
        const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRe.test(email)) errors.push('Email address is not valid.');
      }

      if (phone) {
        const phoneRe = /^[0-9+\-()\s]{7,20}$/;
        if (!phoneRe.test(phone)) errors.push('Phone number is not valid.');
      }

      if (this.UserStatusIdval === 0) errors.push('Please select a user status.');

      return {
        valid: errors.length === 0,
        message: errors.join('<br/>'),
      };
    },
    GetEmployeeAll() {
      // Use overlay for initial load, inline loader for subsequent pages
      if (this.pageNumber === 1) {
        this.onloader = "flex";
      } else {
        this.loading = true;
      }

      let userdata = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        searchValue: 'all',
      };

      this.$store
        .dispatch("Employee/GetEmployeeAll", userdata)
        .then((resp) => {
          if (resp.responseCode == "00") {
            const data = resp.data || [];
            if (Array.isArray(data)) {
              if (this.pageNumber === 1 || !this.AdminUserItem) {
                this.AdminUserItem = data;
              } else {
                this.AdminUserItem = this.AdminUserItem.concat(data);
              }
              // If returned items less than pageSize, no more pages
              this.hasMore = data.length === this.pageSize;
            } else {
              // Fallback: replace
              this.AdminUserItem = resp.data;
              this.hasMore = false;
            }
          }
          this.onloader = "none";
          this.loading = false;
        })
        .catch((err) => {
          this.onloader = "none";
          this.loading = false;
          this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, "");
        });
    },

    loadMore() {
      if (this.loading || !this.hasMore) return;
      this.pageNumber += 1;
      this.GetEmployeeAll();
    },
    GetEmployeeStatus() {
      this.onloader = "flex";
      this.$store
        .dispatch("UserStatus/GetEmployeeStatus")
        .then((resp) => {
          if (resp.responseCode == '00') {
            this.UserStatusItem = resp.data;
          }
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];
    if (
      this.accessDetails.isSuperAdmin == true ||
      this.accessDetails.isAdmin == true
    ) {
      this.GetEmployeeAll();
      this.GetEmployeeStatus();
      // set up intersection observer for infinite scroll
      this.$nextTick(() => {
        try {
          this._infiniteObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.loadMore();
                }
              });
            },
            { root: null, rootMargin: '200px', threshold: 0.1 }
          );
          const sentinel = this.$refs.infiniteSentinel;
          if (sentinel) this._infiniteObserver.observe(sentinel);
        } catch (e) {
          // IntersectionObserver not supported
        }
      });
    } else {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  },

  destroyed() {
    if (this._infiniteObserver) {
      try {
        this._infiniteObserver.disconnect();
      } catch (e) {
        console.error(e);
      }
    }
  },
};
</script>

<style scoped>
/* TRANSITIONS */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* TABLE */
.table-clean {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}

.table-clean th {
  background: #e8f2ff;
  color: #1e3a8a;
}

/* BADGE */
.badge {
  padding: 4px 10px;
  border-radius: 20px;
  background: linear-gradient(135deg, #60a5fa, #2563eb);
  color: white;
  font-size: 12px;
}

/* PAGINATION */
.pagination-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.pagination-buttons {
  display: flex;
  gap: 6px;
}

.page-btn,
.nav-btn {
  min-width: 38px;
  height: 38px;
  border-radius: 10px;
  border: none;
  background: #e0edff;
  color: #1d4ed8;
  cursor: pointer;
  transition: all 0.25s ease;
}

.page-btn:hover,
.nav-btn:hover {
  transform: translateY(-2px);
  background: #bfdbfe;
}

.page-btn.active {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ELLIPSIS LOADER */
.ellipsis {
  display: inline-block;
}

.ellipsis span {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background: #1d4ed8;
  border-radius: 50%;
  opacity: 0.3;
  transform: translateY(0);
  animation: ellipsis 1s infinite;
}

.ellipsis span:nth-child(2) {
  animation-delay: 0.18s;
}

.ellipsis span:nth-child(3) {
  animation-delay: 0.36s;
}

@keyframes ellipsis {
  0% {
    transform: translateY(0);
    opacity: 0.3;
  }

  50% {
    transform: translateY(-6px);
    opacity: 1;
  }

  100% {
    transform: translateY(0);
    opacity: 0.3;
  }
}

/* SKELETON LOADER */
.skeleton-table {
  padding: 20px;
}

.skeleton-row {
  height: 18px;
  margin-bottom: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg,
      #e0edff 25%,
      #f0f7ff 37%,
      #e0edff 63%);
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }

  100% {
    background-position: 400px 0;
  }
}
</style>
